'use strict'

// chunks (replacement characters, tabs, or line endings).

function movePoint(point, offset) {
  point.column += offset
  point.offset += offset
  point._bufferIndex += offset
  return point
}

module.exports = movePoint



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/util/move-point.js
// module id = 1494
// module chunks = 0